const TREE = [
  {
    group: "IMAGE",
    title: "Sticker Tagging",
    name: "sticker_tagging",
    description: "스티커의 적절한 태그들을 예측하는 이미지 기반 기술입니다.",
    descriptionSub: "OGQ GYN 방대한 데이터 셋과 내부 기술을 활용하여 <br class='hide-940' /> 적은 이미지로 높은 인식률을 제공합니다.",
    imgName: 'stickertagging',
    route: {name: 'StickerTagging'},
    isPreparing: false,
    uploadTitle: "스티커 이미지를 넣어주세요.",
    uploadCopy: "가림없이 전체가 나올수록 좋습니다.",
    isNew: true
  },
  {
    group: "IMAGE",
    title: "Deep Tagging",
    name: "deep_tagging",
    description: "이미지 기반 적절한 태그들을 예측하는 기술입니다.",
    descriptionSub: "Multi-label classification 관련 기술을 활용했고, <br class='hide-940' /> 13,000개 태그 중 연관성이 높은 상위 태그들을 제공합니다.",
    extra: "FHD 기준 실행시간 0.2 초",
    imgName: 'deeptagging',
    route: {name: 'DeepTagging'},
    isPreparing: false,
    uploadTitle: "태그를 얻고 싶은 이미지를 넣어주세요.",
    uploadCopy: "어떤 이미지든 다양한 태그들을 추천합니다."
  },
  {
    group: "IMAGE",
    title: "Deep Lens",
    name: "deep_lens",
    description: "80가지 객체 여부를 박스 형태로 예측하는 기술입니다.",
    descriptionSub: "Object detection 관련 기술을 활용하여, 객체 종류 및 좌표 값을 제공합니다.",
    extra: "FHD 기준 실행시간 0.6 초",
    imgName: 'deeplens',
    route: {name: 'DeepLens'},
    isPreparing: false,
    uploadTitle: "사물 또는 사람이 있는 이미지를 넣어주세요.",
    uploadCopy: "가림없이 전체가 나올수록 좋습니다.",
  },
  {
    group: "IMAGE",
    title: "Logo",
    name: "logo",
    description: "이미지 기반 저작권 문제가 있는 특정 로고를<br class='desktop'>찾아주는 기술입니다.",
    descriptionSub: "OGQ GYN 방대한 데이터 셋과 내부 기술을 활용하여 <br/> 적은 이미지로 높은 인식률을 제공합니다.",
    imgName: 'logo',
    route: {name: 'Logo'},
    isPreparing: false,
    uploadTitle: "로고가 있는 이미지를 넣어주세요.",
    uploadCopy: "가림없이 전체가 나올수록 좋습니다.",
    helperTitle: "아래 대표 로고를 인식합니다.",
    helperButtonText: "새로운 로고 요청하기",
    helperList: [
      "android",
      "bmw",
      "botox",
      "christian louboutin",
      "dji",
      "harvard veritas shield",
      "hyundai",
      "i love ny",
      "keep calm and carry on",
      "kia",
      "lego",
      "mcdonalds",
      "mercedesbenz",
      "michelin",
      "monopoly",
      "nba",
      "pepsi",
      "pfizer",
      "pokemon",
      "premier league",
      "smirnoff",
      "starbucks",
      "volkswagen",
    ]
  },
  {
    group: "IMAGE",
    title: "Landmark",
    name: "landmark",
    description: "이미지 기반 가장 유사한 랜드마크를 찾아주는 기술입니다.",
    descriptionSub: "OGQ GYN 방대한 데이터 셋과 내부 기술을 활용하여<br/>적은 이미지로 높은 인식률을 제공합니다.",
    extra: false,
    imgName: 'landmark',
    route: {name: 'Landmark'},
    isPreparing: false,
    uploadTitle: "랜드마크 이미지를 넣어주세요.",
    uploadCopy: "가림없이 전체가 나올수록 좋습니다.",
    helperTitle: "아래 대표 랜드마크를 인식합니다.",
    helperButtonText: "새로운 랜드마크 요청하기",
    helperList: [
      "30 St Mary Axe",
      "Atomium",
      "Beijing National Stadium",
      "Blenheim Palace",
      "Burj Al Arab",
      "Burj Khalifa",
      "Canton Tower",
      "Casa Batllo",
      "Casa Mila",
      "Castel del Monte",
      "Castello Aragonese of Ischia",
      "Chateau de Chenonceau",
      "Chateau de Vaux le Vicomte",
      "Eiffel Tower",
      "Guggenheim Museum Bilbao",
      "London Eye",
      "Louvre Abu Dhabi",
      "Louvre Pyramid",
      "Moulin Rouge",
      "N Seoul Tower",
      "National Centre for the Performing Arts(China)",
      "Peterhof Palace",
      "Petronas Towers",
      "Piazza San Marco (Venice)",
      "Placa de laSagrada Familia",
      "Rosslyn Chapel",
      "San Galgano Abbey",
      "Shrine of Remembrance",
      "Sistine Chapel",
      "Spinnaker Tower",
      "St. Stephen's Cathedral. Vienna",
      "Statue ofthe Little Mermaid (Copenhagen)",
      "Sydney Opera House",
      "Taipei 101",
      "Tokyo Skytree",
      "Viaduc de Millau",
    ]
  },
  {
    group: "IMAGE",
    title: "OCR",
    name: "OCR",
    description: "이미지 내 한글, 영문, 숫자 등 다양한 언어 글자를<br class='desktop'>검출하는 기술입니다.",
    extra: false,
    imgName: 'ocr',
    isPreparing: true,
    uploadTitle: "",
    uploadCopy: "",
  },
  {
    group: "IMAGE",
    title: "Image Inpainting",
    name: "image_inpainting",
    description: "이미지/영상 내 원하는 영역을 자연스럽게<br class='desktop'>지워주는 기술입니다.",
    extra: false,
    imgName: 'imageinpainting',
    isPreparing: true,
    uploadTitle: "",
    uploadCopy: "",
  },
  {
    group: "SECURITY",
    title: "Safety Lens",
    name: "safety_lens",
    description: "작업자의 안전을 확보해주는 기술입니다.",
    descriptionSub: "작업자 별 안전모 착용 여부 및 이미지 내 작업자 수를 제공합니다.",
    extra: "FHD 기준 실행시간 0.5 초",
    imgName: 'safetylens',
    route: {name: 'SafetyLens'},
    isPreparing: false,
    uploadTitle: "안전모를 착용한 사람 이미지를 넣어주세요.",
    uploadCopy: "노란색 안전모를 더 잘 잡습니다.",
  },
  {
    group: "SECURITY",
    title: "Fire Lens",
    name: "fire_lens",
    description: "이미지 내 불꽃, 연기를 검출하여 화재 유무를<br class='desktop'>판단하는 기술입니다.",
    descriptionSub: "Weakly supervised learning 기술 활용하여<br class='hide-940' />  불꽃, 연기 여부 뿐만 아니라 세밀한 영역까지 제공합니다.",
    extra: "FHD 기준 실행시간 2.0 초",
    imgName: 'firelens',
    route: {name: 'FireLens'},
    isPreparing: false,
    uploadTitle: "불꽃, 연기가 나는 이미지를 넣어주세요.",
    uploadCopy: "선명한 사진일수록 더 세밀하게 찾을 수 있습니다.",
  },
  {
    group: "SECURITY",
    title: "Face Lens",
    name: "face_lens",
    description: "얼굴을 감지하여 누구인지 파악하고, 마스크 우뮤를 알려주는 기술입니다.",
    descriptionSub: "AI 기반 얼굴 검출 후 신원, 마스크 착용 여부, 성별 등 <br class='hide-940' /> 얼굴 관련 다양한 정보를 제공합니다.",
    extra: "FHD 기준 실행시간 5.0 초",
    imgName: 'facelens',
    route: {name: 'FaceLens'},
    isPreparing: false,
    uploadTitle: "마스크를 쓴 사람의 이미지를 넣어주세요.",
    uploadCopy: "사람의 얼굴 정면이 모두 나올수록 좋습니다.",
  },
  {
    group: "SECURITY",
    title: "Leak Lens",
    name: "leak_lens",
    description: "배관설비에서 발생하는 누수문제를<br class='desktop'>자동으로 찾아주는 기술입니다.",
    descriptionSub: "딥러닝 기술을 활용하여 배관설비 누수의 확률 수치를 제공합니다.",
    extra: "FHD 기준 실행시간 2.0 초",
    imgName: 'leaklens',
    route: {name: 'LeakLens'},
    isPreparing: false,
    uploadTitle: "물이 새고 있는 배관 이미지를 넣어주세요.",
    uploadCopy: "선명한 사진일수록 더 세밀하게 찾을 수 있습니다.",
  },
]

const getImageItems = ()=> {
  return TREE.filter(({group})=> group === 'IMAGE')
}
const getSecurityItems = ()=> {
  return TREE.filter(({group})=> group === 'SECURITY')
}
const getItemByName = (itemName) => {
  return TREE.find(({name})=> name === itemName)
}
const getItemByNames = (itemNames) => {
  return TREE.filter(({name})=> itemNames.includes(name))
}
const getItemByRouteName = (name) => {
  return TREE.find((item)=> item.route && item.route.name === name)
}

export {
  TREE,
  getImageItems,
  getSecurityItems,
  getItemByName,
  getItemByNames,
  getItemByRouteName
}